import clsx from "clsx";

export default function Indicator({
	size = "default",
}: { size?: "default" | "sm" | "lg" }) {
	const sizeClasses = clsx({
		"w-[8px] h-[8px]": size === "default",
		"w-[6px] h-[6px]": size === "sm",
		"w-[10px] h-[10px]": size === "lg",
	});

	return (
		<div
			className={clsx(
				"relative inline-flex justify-center items-center",
				sizeClasses,
			)}
		>
			<div
				className={clsx(
					"z-[2] inline-flex rounded-full bg-primary-600",
					sizeClasses,
				)}
			/>
			<div
				className={clsx(
					"z-[1] animate-ping absolute inset-0 rounded-full bg-primary-300",
					sizeClasses,
				)}
			/>
		</div>
	);
}
